import { PropsWithChildren, useEffect } from 'react';
import { useChannelContext } from 'scbk-services/channel';

export type MenuInitializerProps = {
    initialized: boolean;
    onInit?: () => void;
} & PropsWithChildren;
/**
 * 채널별 메뉴정보 초기화 컴포넌트
 * @param param0
 * @returns
 */
const MenuInitializer: React.FC<MenuInitializerProps> = ({ initialized, onInit, children }) => {
    const { channel } = useChannelContext();

    useEffect(() => {
        if (!channel) {
            return;
        }

        //앱 초기화 완료가 되었다면.. 메뉴로드 시작
        if (!initialized) {
            console.log(`### MenuInitializer not initialized!`);
            return;
        }

        console.log(`### MenuInitializer [${channel}] 메뉴목록 로드`);

        //메뉴정보는 sc-core에 있기때문에.. onInit 콜백함수에서 초기화를 수행하도록 한다.
        if (onInit) {
            onInit?.();
        }
        //menuLoad(channel);
    }, [channel, initialized]);

    if (!channel || !initialized) {
        return null;
    }

    return <>{children}</>;
};

export { MenuInitializer };
